import React from 'react';

const NoDataPageContainer = ({ iconClass = 'fa fa-info-circle', title, subtitle, actions = null, children }) => {
  return (
    <div className={`app-container app-theme-white body-tabs-shadow fixed-header`}>
      <div className="app-main d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="app-main__outer w-100 px-3" style={{ maxWidth: '720px' }}>
          <div className="app-main__inner text-center">
            
            {/* Icon */}
            <div className="mb-3">
              <i className={`${iconClass} fa-3x text-primary`} />
            </div>

            {/* Title */}
            {title && <h4 className="text-dark">{title}</h4>}

            {/* Subtitle */}
            {subtitle && <p className="text-muted">{subtitle}</p>}

            {/* Custom Content (optional) */}
            {children && <div className="mt-3">{children}</div>}

            {/* Actions (buttons, links, etc) */}
            {actions && <div className="mt-4">{actions}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoDataPageContainer;
